import { useMemo } from 'react';

import { useUser } from '@auth0/nextjs-auth0/client';
import { Box } from '@mui/material';

import {
  AbroadLeadPersonalData,
  AbroadLeadPlanning,
  MeetingFormComponent,
  MessageUnlockComponent,
  PremiumPlanRedeem,
} from 'components/AbroadComponentsV2/SharedComponents/LeadForm/FormWrapper/components';

import { useLead } from 'providers/LeadProvider';

import {
  isSalesExecutiveSession,
  getSalesExecutiveCode,
} from 'utils/auth/authHelper';

export default function FormWrapper({
  buttonText = 'Avançar',
  cityId = 0,
  countries = [],
  countryId = 0,
  courseId = 1,
  id = 'widget-sales-executive',
  onMessageSuccess = () => {},
  onSubmitSecondStep = () => {},
  schoolsFilters = {},
  shouldScheduleMeeting = false,
}) {
  const { isPremiumPlanUser, step } = useLead({
    shouldScheduleMeeting,
  });
  const { user } = useUser();

  const isExpert = user && isSalesExecutiveSession(user);
  const salesExecutiveCode = isExpert ? getSalesExecutiveCode(user) : null;

  const countriesData = useMemo(
    () =>
      countries.filter((c) =>
        schoolsFilters.languageFilters.find((lf) => lf.slugName === c.slugName)
      ),
    [countries, schoolsFilters]
  );

  const getStepContent = () => {
    if (isPremiumPlanUser) {
      return <PremiumPlanRedeem />;
    }

    switch (step) {
      case 1:
        return (
          <AbroadLeadPersonalData
            buttonText={buttonText}
            cityId={cityId}
            countries={countriesData}
            countryId={countryId}
            courseId={courseId}
            id={`${id}-1`}
            schoolFilters={schoolsFilters}
            salesExecutiveCode={salesExecutiveCode}
          />
        );

      case 2:
        return (
          <AbroadLeadPlanning
            buttonText={buttonText}
            id={`${id}-2`}
            onSubmitSecondStep={onSubmitSecondStep}
            salesExecutiveCode={salesExecutiveCode}
          />
        );

      case 3: {
        return <MeetingFormComponent buttonText={buttonText} />;
      }

      default:
        return (
          <MessageUnlockComponent
            countries={countriesData}
            onMessageSuccess={onMessageSuccess}
          />
        );
    }
  };

  return <Box sx={{ py: 2, px: { xs: '0', md: 3 } }}>{getStepContent()}</Box>;
}
